import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Box } from "@material-ui/core";
import Slide from "@material-ui/core/Slide";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DialogAlert = (props) => {
  let positiveButtonTitle;
  if (props.positiveButtonTitle) {
    positiveButtonTitle = props.positiveButtonTitle;
  } else {
    positiveButtonTitle = "Delete";
  }

  let negativeButtonTitle;
  if (props.negativeButtonTitle) {
    negativeButtonTitle = props.negativeButtonTitle;
  } else {
    negativeButtonTitle = "Cancel";
  }

  return (
    <div>
      <Dialog
        open={props.show}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <Box display="flex" alignItems="center">
          {!props.icon && <WarningRoundedIcon className="rounded-icon" />}
          <DialogTitle id="alert-dialog-slide-title" className="dialog-title">
            {props.title}
          </DialogTitle>
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {props.children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.handleYes && (
            <Button onClick={props.handleYes} className="dialog-button">
              {positiveButtonTitle}
            </Button>
          )}
          <Button onClick={props.handleNo} color="primary">
            {negativeButtonTitle}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DialogAlert;
